type Props = {
  width?: string;
  height?: string;
  fillColor?: string;
};

export const MuxPlayIcon = (props: Props) => {
  const { width = '24', height = '24', fillColor = '#FFFFFF' } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 24 24">
      <path
        d="m6.73 20.93 14.05-8.54a.46.46 0 0 0 0-.78L6.73 3.07a.48.48 0 0 0-.73.39v17.07a.48.48 0 0 0 .73.4Z"
        fill={fillColor}
      />
    </svg>
  );
};
